// extracted by mini-css-extract-plugin
export default {"unit-address-title":"unit-address-title-570e","unit-address-title__text":"unit-address-title__text-0868"};